import React from 'react';
import BarChartItem from './BarChartItem';
import cx from './index.module.scss';

import years from '../../assets/years.data';

const BarChart = ({ slideIndex, company, clickedYears, onClick }) => {
  return (
    <div className={cx.wrap}>
      {(!clickedYears && !company) && (
        <div className={cx.title}>
          <img className={cx.image} src={`${process.env.PUBLIC_URL}/images/title_bar_chart.png`} alt="연도별 회사 분포" />
        </div>
      )}
      <div className={cx.bars}>
        {years.map((item, index) => (
          <BarChartItem
            key={`bar-chart-item-${item}`}
            isActivated={index === slideIndex}
            isVisible={!(clickedYears || company)}
            years={item}
            onClick={onClick}
          />
        ))}
      </div>
      <div className={cx.line} />
    </div>
  );
};

export default BarChart;
